import { Avatar, Flex, IconButton, useDisclosure } from "@chakra-ui/react";
import { SideBar } from "../SideBar";
import { Menu } from "@material-ui/icons";

export const Header = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const user = JSON.parse(localStorage.getItem("profile"));

  return (
    <>
      <Flex
        w="full"
        p={2}
        bgColor="telegram.500"
        alignItems="center"
        top="0"
        pos="sticky"
        justifyContent="space-between"
      >
        <Avatar src={user?.profileUrl} />
        <IconButton variant="ghost" icon={<Menu />} onClick={onOpen} />
      </Flex>
      <SideBar isOpen={isOpen} onClose={onClose} />
    </>
  );
};
